import {
  ProposalClientView,
  ProposalDocReview,
  ProposalFilters,
  ProposalManagementView,
  defaultProposalFilters,
} from './proposal.model';

export interface IProposalState {
  proposalsForReview: ProposalClientView[];
  proposalByCreator: ProposalManagementView[];
  myProposals: ProposalClientView[];
  selectedProposal: ProposalDocReview | null;
  document: Blob | null;
  filters: ProposalFilters;
  totalCount: number;
  isLoading: boolean;
  isLoadingMyProposals: boolean;
  isLoadingSelectedProposal: boolean;
  isLoadingDocument: boolean;
  error: string | null;
}

export const initialUIState: IProposalState = {
  proposalsForReview: [],
  proposalByCreator: [],
  myProposals: [],
  selectedProposal: null,
  document: null,
  filters: { ...defaultProposalFilters },
  totalCount: 0,
  isLoading: false,
  isLoadingMyProposals: false,
  isLoadingSelectedProposal: false,
  isLoadingDocument: false,
  error: null,
};
